import { createRouter, createWebHistory } from 'vue-router'

import EventsMap from '@/views/EventsMap.vue'
import StoresMap from '@/views/StoresMap.vue'

const basename = import.meta.env.PUBLIC_APP_BASENAME

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: `${basename}/events`,
      name: 'eventmap',
      component: EventsMap,
    },
    {
      path: `${basename}/stores`,
      name: 'storesmap',
      component: StoresMap,
    },
    {
      path: `${basename}/events/:subtype`,
      name: 'eventSubType',
      component: EventsMap,
    },
  ],
})

export default router
